import { useState } from 'react'
import { Divider, Result, Progress, Button, Typography, Upload } from 'antd'
import {
  CheckOutlined
  CloseOutlined
  HistoryOutlined
  UploadOutlined
  QuestionOutlined
} from '@ant-design/icons'
import GeneralTemplate from './general'
import { getRandomUpload } from '../funnies'
import { pluginStatuses } from 'Services/ActionsPagesUtils'
import AceEditor from 'react-ace'
import moment from 'moment'

import 'ace-builds/src-noconflict/mode-c_cpp'
import 'ace-builds/src-noconflict/theme-github'

{ Text } = Typography

JSONEditor = GeneralTemplate({
  InputHandler: ({ inputState, setInputState, startPlugin }) ->

    <>
      <AceEditor
        defaultValue={inputState}
        onChange={(val) -> setInputState(val) }
        height="100px"
        style={{ width: 'calc(100% - 40px)', margin: 20, marginBottom: 40 }}
        setOptions={{ readOnly: false }}
        mode="json"
        theme="solarized_light"
      />
      <Button
        type="primary"
        shape="round"
        block
        ghost
        onClick={-> startPlugin({ json: inputState })}
      >
        Run
      </Button>
    </>
})

export default JSONEditor
